function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M37.5 3.75h-35v13h35v-13zM19 23.25H2.5v13h16M10.453 10.25H7.271M10.453 29.75H7.271",
  stroke: "currentColor",
  strokeWidth: 3,
  strokeLinecap: "square"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M31.137 11.875c.878 0 1.59-.727 1.59-1.625 0-.897-.712-1.625-1.59-1.625-.879 0-1.591.728-1.591 1.625 0 .898.712 1.625 1.59 1.625z",
  fill: "#4038FF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M6.875 17.156v5.688",
  stroke: "currentColor",
  strokeWidth: 3,
  strokeLinecap: "square"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M29.625 22.75l2.125 4.526 4.75.726-3.438 3.523.812 4.975-4.249-2.349-4.249 2.349.811-4.975-3.437-3.523 4.75-.726 2.125-4.526z",
  stroke: "currentColor",
  strokeWidth: 3,
  strokeLinecap: "round"
});

var SvgStorageProviderLead = function SvgStorageProviderLead(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    color: "#4038ff"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgc3R5bGU9ImNvbG9yOiM0MDM4RkY7IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMzcuNSAzLjc1SDIuNVYxNi43NUgzNy41VjMuNzVaIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIzIiBzdHJva2UtbGluZWNhcD0ic3F1YXJlIi8+CjxwYXRoIGQ9Ik0xOSAyMy4yNUgyLjVWMzYuMjVIMTguNSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMyIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIvPgo8cGF0aCBkPSJNMTAuNDUzMyAxMC4yNDk5SDcuMjcxNDgiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjMiIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiLz4KPHBhdGggZD0iTTEwLjQ1MzMgMjkuNzQ5OUg3LjI3MTQ4IiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIzIiBzdHJva2UtbGluZWNhcD0ic3F1YXJlIi8+CjxwYXRoIGQ9Ik0zMS4xMzY4IDExLjg3NUMzMi4wMTU0IDExLjg3NSAzMi43Mjc3IDExLjE0NzUgMzIuNzI3NyAxMC4yNUMzMi43Mjc3IDkuMzUyNTQgMzIuMDE1NCA4LjYyNSAzMS4xMzY4IDguNjI1QzMwLjI1ODIgOC42MjUgMjkuNTQ1OSA5LjM1MjU0IDI5LjU0NTkgMTAuMjVDMjkuNTQ1OSAxMS4xNDc1IDMwLjI1ODIgMTEuODc1IDMxLjEzNjggMTEuODc1WiIgZmlsbD0iIzQwMzhGRiIvPgo8cGF0aCBkPSJNNi44NzUgMTcuMTU2MlYyMi44NDM4IiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIzIiBzdHJva2UtbGluZWNhcD0ic3F1YXJlIi8+CjxwYXRoIGQ9Ik0yOS42MjUgMjIuNzVMMzEuNzQ5OCAyNy4yNzYxTDM2LjUgMjguMDAxOUwzMy4wNjI1IDMxLjUyNDdMMzMuODczOCAzNi41TDI5LjYyNSAzNC4xNTExTDI1LjM3NjMgMzYuNUwyNi4xODc1IDMxLjUyNDdMMjIuNzUgMjguMDAxOUwyNy41MDAyIDI3LjI3NjFMMjkuNjI1IDIyLjc1WiIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+Cjwvc3ZnPgo=";
export { SvgStorageProviderLead as ReactComponent };